module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1005-f7bd647021248cc2e1a33a476bf511e1.png";